import React from 'react';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';

const LinksTab: React.FC = () => {
  return (
    <Typography>
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://websurrogates.nycourts.gov/Home/Welcome/?ReturnUrl=%2fNames%2fNameSearch"
          >
            NY WebSurrogate
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://iapps.courts.state.ny.us/nyscef/Login"
          >
            NYS e-Courts/e-Filings
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.bronxcountyclerkinfo.com/blds/pages/docsearch.aspx"
          >
            Bronx Lien Search
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.bronxcountyclerkinfo.com/law/UI/User/lne.aspx"
          >
            Clerks Mins Bronx Search
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://nycourts.gov/courts/2jd/kingsclerk/jury.shtml"
          >
            Clerks Mins Kings Search
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.nycourts.gov/COURTS/11jd/queensclerk/documents.shtml"
          >
            Clerks Mins Queens Search
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://iapps.courts.state.ny.us/iscroll/jcaptcha"
          >
            NY County Clerk
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://richmondcountyclerk.com/"
          >
            Richmond County Clerk
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www1.nyc.gov/site/finance/taxes/acris.page"
          >
            ACRIS
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://arbsbackplant.datatracetitle.com/ArbMapsLogin.aspx"
          >
            ARB
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://gis.nyc.gov/taxmap/"
          >
            NYC Tax Map Link
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://web.datatree.com/#/home"
          >
            DataTree Web
          </a>
        </li>
      </ul>
    </Typography>
  );
};

export default React.memo(LinksTab);
